import * as styles from "src/components/SelectV2/SelectV2.style.ts";

import { type UseInteractionsReturn } from "@floating-ui/react";

import React, { type MutableRefObject } from "react";

import type { Option as IOption } from "./SelectV2.types.ts";

import { type VirtualItem } from "@tanstack/react-virtual";

export const Option = ({
  item,
  activeIndex,
  flatOptions,
  virtualItem,
  interactions,
  onSelect,
  listRef,
  isMultiple,
  value,
}: {
  item: IOption<any>;
  activeIndex: number | null;
  flatOptions: IOption<any>[];
  isMultiple: boolean;
  value: any;
  virtualItem?: VirtualItem;
  interactions: UseInteractionsReturn;
  onSelect: (item: IOption<any>) => void;
  listRef: MutableRefObject<Array<HTMLElement | null>>;
}) => {
  const getItemActualIndex = (item: IOption<any>) => {
    return flatOptions.findIndex(
      (flatOption) => flatOption.value === item.value,
    );
  };
  const actualIndex = getItemActualIndex(item);
  const setItemRef = (node: HTMLDivElement | null) => {
    listRef.current[actualIndex] = node;
  };

  const isSelected = isMultiple
    ? Array.isArray(value)
      ? value.includes(item.value)
      : false
    : item.value === value;

  return (
    <div
      css={[
        styles.listItem({
          disabled: item.disabled,
          isActive: actualIndex === activeIndex,
          isSelected: isSelected,
        }),
        virtualItem
          ? styles.virtualOption({
              virtualItem,
            })
          : undefined,
      ]}
      tabIndex={-1}
      ref={setItemRef}
      {...interactions.getItemProps({
        onClick: () => onSelect(item),
      })}
    >
      {item.renderOption ? (
        item.renderOption(item)
      ) : (
        <div css={styles.listItemInner}>{item.label}</div>
      )}
    </div>
  );
};
